import { render, staticRenderFns } from "./HandsUpGameContainer.vue?vue&type=template&id=717108da&scoped=true&lang=pug&"
import script from "./HandsUpGameContainer.vue?vue&type=script&lang=js&"
export * from "./HandsUpGameContainer.vue?vue&type=script&lang=js&"
import style0 from "./HandsUpGameContainer.vue?vue&type=style&index=0&id=717108da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717108da",
  null
  
)

export default component.exports